import { render } from "./SubGrupoCreate.vue?vue&type=template&id=656df71f&scoped=true"
import script from "./SubGrupoCreate.vue?vue&type=script&lang=js"
export * from "./SubGrupoCreate.vue?vue&type=script&lang=js"

import "./SubGrupoCreate.vue?vue&type=style&index=0&id=656df71f&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656df71f"]])

export default __exports__